import { internalUnits, mmolL, mgdL } from './consts';
import { urlDateFormat } from './formats';

export const glucoseMolarMass = 18.01559;

export const idKey = d => d.id || d;
export const idOrTimeKey = d => d.id || d.time;
export const nameKey = d => d.name || d;
export const dayKey = d => urlDateFormat(new Date(d.time));

export function guessGlucoseUnit(value) {
  if (value >= 0 && value < 35) {
    return mmolL;
  }
  if (value >= 35 && value < (35 * glucoseMolarMass)) {
    return mgdL;
  }
  throw new Error(`Cannot guess the units for glucose value ${value}`);
};

function getFromPossibleValues(d) {
  if (!isNaN(d.sgv)) {
    return d.svg;
  }
  if (!isNaN(d.smbg)) {
    return d.smbg;
  }
  if (!isNaN(d.glucose)) {
    return d.glucose;
  }
  if (!isNaN(d.value)) {
    return d.value;
  }
  return d;
}

export function glucoseAccessor(d) {
  const glucoseValue = getFromPossibleValues(d);
  const unit = d.unit ? d.unit.toLowerCase() : guessGlucoseUnit(glucoseValue);
  if (unit === internalUnits) {
    return glucoseValue;
  }
  if (unit === mmolL && internalUnits === mgdL) {
    return glucoseValue * glucoseMolarMass;
  }
  if (unit === mgdL && internalUnits === mmolL) {
    return glucoseValue / glucoseMolarMass;
  }
  throw new Error(`Cannot convert value ${glucoseValue} from ${unit} to ${internalUnits}`);
};

export function timeAccessor(d) {
  if (!d.time) {
    console.warn('Invalid use of timeAccessor', d);
    return d;
  }
  if (d.time.getTime) {
    return d.time;
  }
  return new Date(d.time);
}

export function timeSort(a, b) {
  return timeAccessor(a).getTime() - timeAccessor(b).getTime();
}

